import React from 'react';
import { useLocation } from 'react-router-dom';
import LocalizedLink from '../atoms/LocalizedLink';

interface MobileNavLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  exact?: boolean;
  onClick?: () => void;
}

const MobileNavLink: React.FC<MobileNavLinkProps> = ({
  to,
  children,
  className = '',
  exact = false,
  onClick,
}) => {
  const location = useLocation();
  const isActive = exact
    ? location.pathname === to
    : location.pathname.startsWith(to.split('#')[0]);

  return (
    <LocalizedLink
      to={to}
      className={`
        block px-3 py-2 rounded-md text-base font-medium 
        ${isActive
          ? 'bg-tlc-navy/10 text-tlc-navy'
          : 'text-gray-700 hover:bg-gray-100 hover:text-tlc-navy'}
        ${className}
      `}
      onClick={onClick}
      aria-current={isActive ? 'page' : undefined}
    >
      {children}
    </LocalizedLink>
  );
};

export default MobileNavLink; 